function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { simplePath } from "../utils.js";
const GET_USER_PROJECT_LIST_PATH = "/v2/user/:userEmail/project-list";
function get_user_project_list_path(params) {
    return simplePath(GET_USER_PROJECT_LIST_PATH, params);
}
class UserProjectContributor {
    constructor(){
        _define_property(this, "id", void 0);
        _define_property(this, "name", void 0);
        _define_property(this, "type", void 0);
        _define_property(this, "avatarColor", void 0);
        _define_property(this, "username", void 0);
    }
}
export { GET_USER_PROJECT_LIST_PATH, UserProjectContributor, get_user_project_list_path };
